export const greaterThan = (a, b) => {
  return Number(a) > Number(b);
};
